module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/SustainableBadass4#_idTextAnchor002"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Chapter 1 "), _c('br'), _c('br')]), _c('span', {
    staticClass: "green CharOverride-11"
  }, [_vm._v("The Plastic Problem"), _c('span', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  })]), _c('span', {
    staticClass: "CharOverride-11"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_Special-Body_ChOp-Body"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("The first time I ever noticed the term “zero waste” was in an article about a woman from New York who could fit all her trash of three years into a single mason jar. I thought that sounded fascinating because I was making more trash than that just during an average day. That article started something in me, because I had never actually thought about my trash and where it ends up. Okay, I knew that it, of course, did not just disappear into thin air but that the trash pickup would take care of it and send it off to a local waste plant—so far so good. But I paid very little attention to my trash, and because of this, it felt like stepping into a completely new world when I started to find out what the problems with plastic actually are. So, I think it’s only fitting that this book will start in the same place that I started my own journey toward sustainability, and that is with the plasti")]), _c('span', {
    staticClass: "noBreak CharOverride-12"
  }, [_vm._v("c")]), _c('span', {
    staticClass: "noBreak CharOverride-12"
  }), _c('span', {
    staticClass: "noBreak CharOverride-12"
  }, [_vm._v("problem.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a4f06d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SustainableBadass-7.vue
// module id = 81
// module chunks = 0